import { z } from 'zod';

export const DECOMMISSION_ACK_QUEUE_NAME = 'id-decommission-ack';

const decommissionAckBaseSchema = z.object({
  requestId: z.string().min(1),
  service: z.string().min(1),
});

export const decommissionAckDTOSchema = z.discriminatedUnion('status', [
  decommissionAckBaseSchema.extend({ status: z.literal('completed') }),
  decommissionAckBaseSchema.extend({ status: z.literal('failed'), error: z.string().min(1) }),
]);

export type DecommissionAckDTO = z.output<typeof decommissionAckDTOSchema>;
